module.exports = __webpack_public_path__ + "img/icon_permission.9de9c2b1.svg";